import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "link-content p-4"
};
const _hoisted_2 = {
  class: "top label"
};
const _hoisted_3 = {
  key: 0,
  class: "mt-4"
};
const _hoisted_4 = {
  class: "label"
};
import { promiseTimeout } from '@vueuse/core';
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { animateProgress } from '@utils/window-helpers';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import { assessNodeTaskRestart } from '@views/main/api';
import FoldBox from '../FoldBox.vue';
import initIncrementalUpdate from './mixins/incrementalUpdate.mixin';
export default /*@__PURE__*/_defineComponent({
  __name: 'LinkScraping',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const mainStore = useMainStore();
    const {
      incrementalMessageList
    } = storeToRefs(mainStore);
    const foldBoxRef = ref();
    const scrollRef = ref();
    const info = ref({});
    const showTitle = computed(() => {
      if (info.value.executeStatus === 3) {
        return `任务1：完成浏览【${info.value.url}】本次获取${info.value.linkTotal || 0}个页面，AI将抽样浏览${info.value?.links.length || 0}个页面`;
      }
      if (info.value.executeStatus === 2) {
        return `任务1：浏览失败，${info.value?.remark || ''}`;
      }
      return `任务1：正在浏览【${info.value.url}】`;
    });
    // 处理websocket推送消息
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      const {
        incrementalData
      } = message;
      props.item.newLoad = false;
      if (incrementalData.data.executeStatus === 2) {
        info.value.executeStatus = 2;
        info.value.remark = incrementalData.data.remark;
        return;
      }
      if (incrementalData.data.links) {
        foldBoxRef.value?.setIsFold(true);
        const newLinks = incrementalData.data.links || [];
        info.value.linkTotal = incrementalData.data.linkTotal || 0;
        let currentIndex = 0;
        const chunkSize = 1; // 每次更新的数量
        animateProgress(() => {
          const endIndex = Math.min(currentIndex + chunkSize, newLinks.length);
          info.value.links = [...(info.value.links || []), ...newLinks.slice(currentIndex, endIndex)];
          currentIndex = endIndex;
          scrollRef.value?.scrollTo({
            top: scrollRef.value.scrollHeight,
            behavior: 'smooth'
          });
          if (currentIndex >= newLinks.length) {
            info.value.executeStatus = 3;
            mainStore.loadNextMsg(props.item);
            return false; // 结束动画
          }
          return true; // 继续执行
        }, 100); // 时间间隔调整为50ms
      }
    });
    const handleRestart = async () => {
      try {
        await assessNodeTaskRestart({
          sessionId: mainStore.msgParams.sessionId,
          taskNode: props.item.messageType
        });
        info.value.executeStatus = 1;
      } catch (error) {
        console.log(error);
      }
    };
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
    });
    onMounted(async () => {
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
      }
      try {
        if (props.item.newLoad) {
          await promiseTimeout(2000);
          props.item.newLoad = false;
        }
        info.value = props.content;
        // 处理增量数据
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
      } catch (error) {
        info.value = {};
        console.log(error);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createBlock(FoldBox, {
        ref_key: "foldBoxRef",
        ref: foldBoxRef,
        id: props.item.id,
        status: info.value.executeStatus || 1,
        loading: __props.item.newLoad,
        onRestart: handleRestart
      }, {
        loading: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" 收到任务： ", -1), _createElementVNode("span", {
          class: "text-[#767679]"
        }, "链接分析中", -1)]))]),
        title: _withCtx(() => [_createTextVNode(_toDisplayString(showTitle.value), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createTextVNode(" 分析网址： ", -1)), _createVNode(_component_el_link, {
          type: "primary",
          href: info.value.url,
          target: "_blank"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(info.value.url), 1)]),
          _: 1
        }, 8, ["href"])]), info.value.links ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, "发现" + _toDisplayString(info.value.links.length) + "个页面", 1), _createElementVNode("div", {
          ref_key: "scrollRef",
          ref: scrollRef,
          class: "mt-2 max-h-[200px] overflow-y-auto"
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.links, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item
          }, [_createVNode(_component_el_link, {
            type: "primary",
            href: item,
            target: "_blank"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
            _: 2
          }, 1032, ["href"])]);
        }), 128))], 512)])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["id", "status", "loading"]);
    };
  }
});